import { Check, Copy } from "lucide-react"
import { PropsWithChildren } from "react"
import { Button } from "../../atoms/Button"
import { useCopyToClipboard } from "../../hooks/useCopyToClipboard"
import { cn } from "../../utils"

export function CopyButtonWrapper({ children }: PropsWithChildren) {
  return <div className="inline-block relative group/copy">{children}</div>
}

type CopyButtonProps = {
  content: string
  copyMessage?: string
  errorMessage?: string
  className?: string
  positioning?: boolean
}

export function CopyButton({
  content,
  copyMessage,
  errorMessage,
  className,
  positioning = true,
}: CopyButtonProps) {
  const { isCopied, onCopy } = useCopyToClipboard({
    text: content,
    copyMessage,
    errorMessage,
  })

  const body = (
    <Button
      variant="link"
      size="icon"
      className={cn("relative h-6 w-6", className)}
      onClick={onCopy}
    >
      <div className="absolute inset-0 flex items-center justify-center">
        <Check
          className={cn(
            "h-4 w-4 transition-transform ease-in-out",
            isCopied ? "scale-100" : "scale-0",
          )}
        />
      </div>
      <Copy
        className={cn(
          "h-4 w-4 transition-transform ease-in-out",
          isCopied ? "scale-0" : "scale-100",
        )}
      />
    </Button>
  )

  if (positioning) {
    return (
      <div className="invisible absolute right-0.5 top-0.5 bg-background border flex space-x-1 rounded-lg p-1 opacity-0 transition-all duration-200 group-hover/copy:visible group-hover/copy:opacity-100">
        {body}
      </div>
    )
  }

  return body
}
